export default {
  API_URL: 'https://fcc-api.cometrootapp.com/api/',
  SANDBOX_URL: 'https://fccsandbox-api.cometrootapp.com/api/'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
